import { strategyToOptions } from "@/common/utils/strategyToOptions"
import { CompanyData } from "@/features/companies/types/companies.type";

export const logReasonRequirement: Record<CompanyData['update_user_log_reason_requirement'], string> = {
  none: 'Não',
  required: 'Sim',
}

export const logReasonRequirementOptions = strategyToOptions(logReasonRequirement);
